<template>
  <div class="visualisation-date-wrapper">
    <v-progress-circular
      :size="size ? size : 50"
      :width="width ? width : 10"
      :rotate="-90"
      :value="value"
      :color="getColor"
    >
      {{ value }}
    </v-progress-circular>
  </div>
</template>

<script>
  export default {
      props: ['value', 'size', 'width'],
      computed: {
          getColor () {
              if (this.value >= 0 && this.value <= 59) {
                return 'error'
              } else if (this.value >= 60 && this.value <= 89) {
                return 'warning'
              } else {
                return 'success'
              }
          }
      }
  }
</script>
